<template>
  <div class="input_wrap">
    <p>{{ title }}</p>

    <input
      :type="type"
      v-model="inputData"
      :placeholder="placeholder"
      :id="id"
      :required="required"
      :name="name"
      @keyup="$emit('update:inputData', inputData)"
      v-on:keyup.enter="$emit('update:inputData', inputData)"
    />

    <button
      class="eye"
      v-if="shwoPass"
      @click.prevent="show_pass"
      :class="{ visible: type == 'text' }"
    ></button>

    <div class="error_notificatin df s_center" v-if="hasError">
      <img src="@/assets/img/error_icon.svg" alt="" />
      {{ errorText }}
    </div>
  </div>
</template>

<script>
export default {
  name: "inputWrap",
  props: {
    title: String,
    type: String,
    placeholder: String,
    inputData: String,
    errorText: String,
    hasError: Boolean,
    id: String,
    name: String,
    required: Boolean,
    shwoPass: Boolean,
  },

  methods: {
    show_pass() {
      if (this.type == "text") {
        this.type = "password";
      } else {
        this.type = "text";
      }
    },
  },
};
</script>

<style lang="scss">
.input_wrap {
  width: 100%;
  margin-bottom: 32px;

  @media all and (max-width: 767px) {
    margin-bottom: 16px;
  }

  p {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: normal;
    line-height: 24px;
    text-align: left;
  }

  input {
    padding-bottom: 15px;
    padding-top: 8px;
    background-color: transparent;
    width: 100%;
    border-bottom: 1px solid #d1cdc9;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    transition: color 180ms ease-in-out;

    &:-webkit-autofill,
    &:-webkit-autofill:focus {
      transition: background-color 600000s 0s, color 600000s 0s;
    }

    &::-webkit-input-placeholder {
      color: rgba(0, 0, 0, 0.32);
      font-family: "Nunito Sans", sans-serif;
      font-weight: 400;
    }
  }

  .eye {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 10px;
    bottom: 10px;
    background: url("../assets/img/show_pass_icon.svg") no-repeat center /
      contain;

    &.visible {
      background: url("../assets/img/show_pass_icon_visible.svg") no-repeat
        center / contain;
    }
  }
}
</style>